import Service from "@/utils/api/service";
import Pagination from "@/components/share/pagination";
import Helper from "@/utils/global/func";
import TableLoading from "@/components/share/table-loading";
import NoItem from "@/components/share/table-no-item";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Multiselect from "vue-multiselect";
import { mapState } from "vuex";

export default {
  name: "ListTrainingCourse",
  data() {
    return {
      isFetching: true,
      isDeleting: false,
      isNoData: false,
      search: {
        dateRange: [],
        sort: "",
        cardCode: "",
      },
      data: {
        limit: 10,
        detail: {},
        items: [],
        pagination: {
          limit: 10,
          page: 1,
          total: 0,
          totalPage: 0,
        },
      },
      sorts: [
        { id: "ASC", name: "Ascending" },
        { id: "DESC", name: "Descending" },
      ],
    };
  },
  components: {
    Pagination,
    TableLoading,
    NoItem,
    DatePicker,
    Multiselect,
  },
  created() {
    this.setParams();
    this.getList();
  },
  watch: {
    "$route.fullPath": function () {
      this.setParams();
      this.getList();
    },
  },
  computed: {
    ...mapState(["permissions"]),
  },
  mounted() {},
  methods: {
    setParams() {
      const query = this.$route.query;
      this.search = this.$helper.setParams(this.search, query);

      if (query.startDate && query.endDate) {
        this.search.dateRange = [query.startDate, query.endDate];
      } else {
        this.search.dateRange = [];
      }
    },

    checkoutPermission(permissionName) {
      if (this.permissions) {
        let result = false;
        this.permissions.find((item) => {
          item.permissions.find((permission) => {
            if (permission.name == permissionName) {
              result = true;
            }
          });
        });

        return result;
      }
    },

    getFullImage(path) {
      return process.env.VUE_APP_BASE_URL_IMAGE + path;
    },

    htmlToText(html) {
      return Helper.convertToPlain(html);
    },

    linkPage(type, index) {
      if (index >= 0) {
        this.$router.push({
          name: type,
          query: { id: this.data.items[index].id },
        });
      } else
        this.$router.push({
          name: type,
        });
    },

    async searching() {
      let query = this.$helper.filterKeyMapping({
        limit: 10,
        page: 1,
        ...this.search,
      });
      await this.$router.push({ query }).catch(() => {});
    },

    getList() {
      this.isFetching = true;
      this.isNoData = false;
      let query = this.$root.$route.query;
      let setQuery = this.$helper.filterKeyMapping({
        page: query?.page || 1,
        sort: this.search?.sort?.id ?? "",
        cardCode: this.search.cardCode,
        ...query,
      });

      let params = this.$helper.queryParam(setQuery);

      Service.listTrainingCourses(params).then((response) => {
        this.isFetching = false;
        if (response?.statusCode) {
          if (response?.statusCode === "4410") {
            Service.refreshToken().then((response) => {
              if (response === "ok") {
                this.getList();
              }
            });
          } else if (response?.statusCode === "403") {
            this.isNoData = true;
            this.data.items = [];
            this.$toasted.show(response?.message);
            return;
          } else {
            this.$toasted.show(response?.message);
            return;
          }
        } else {
          if (response?.data.length > 0) {
            this.isNoData = false;
            this.data.items = response?.data;
            this.data.pagination = Helper.calculatePagination(response?.meta);
            return;
          } else {
            this.data.items = [];
            this.isNoData = true;
            return;
          }
        }
      });
    },
  },
};
